<template>
    <div class="information-wrapper">
        <Head :title="$tc('header.back')"/>
        <div class="information-inner" v-html="content"></div>
        <Empty :emptydata="emptydata" v-if="emptydata"/>
    </div>
</template>

<script>

import { mapMutations } from 'vuex'

export default {
    name: 'Information',
    data () {
        return {
            content: '',
            emptydata: null
        }
    },
    props: ['name'],
    created () {
        this.getData()
    },
    mounted () {
        this.$nextTick(() => {
            this.$Common.pageShare()
        })
    },
    methods: {
        ...mapMutations(['setShowLoading']),
        getData () {
            this.$Api.statement({}).then((data) => {
                this.content = (data && data[this.name]) || ''
                if (!data || !this.content) {
                    this.emptydata = {
                        type: 'nodata'
                    }
                }
                this.setShowLoading(false)
            }).catch(() => {
                this.emptydata = {
                    type: 'nonetwork'
                }
                this.setShowLoading(false)
            })
        }
    }
}
</script>

<style lang="scss">
    .information-inner {
        padding: 3.571vw 2.786vw;
        word-wrap: break-word;
        img {
            max-width: 100%;
            width: auto;
        }
    }
</style>
